var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCirclePlusGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.804688,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.804688,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#546223"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 13.3047C20.4526 13.3047 20.8194 13.6716 20.8194 14.1241L20.8194 26.4853C20.8194 26.9378 20.4526 27.3047 20 27.3047C19.5474 27.3047 19.1806 26.9378 19.1806 26.4853V14.1241C19.1806 13.6716 19.5474 13.3047 20 13.3047Z",
    fill: "#546223"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 20.3047C27 20.7572 26.6331 21.1241 26.1806 21.1241H13.8194C13.3669 21.1241 13 20.7572 13 20.3047C13 19.8521 13.3669 19.4853 13.8194 19.4853H26.1806C26.6331 19.4853 27 19.8521 27 20.3047Z",
    fill: "#546223"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlusGreen);
export default __webpack_public_path__ + "static/media/circle-plus-green.960c474470503dc63f555eef7dd57946.svg";
export { ForwardRef as ReactComponent };